import ExternalLogger from "../../../logger/ExternalLogger";

var ContactModalController = function ($scope, $state, $modalInstance) {
    /**
     * Logger.
     */
    var logger = ExternalLogger.getInstance("ContactModalController");

    /**
     *  Close modal window
     **/
    $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
    };

    function init() {
        logger.debug("init()");
    }

    init();
};

ContactModalController.$inject = ["$scope", "$state", "$modalInstance"];
export default ContactModalController;
